export default __webpack_public_path__ + "static/media/twitter.b6886592.png";